import React, { Component } from 'react';
import TextField from 'material-ui/TextField';

// We can inject some CSS into the DOM.
const Props = (title, lines, hintText) => ({
  //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  multiLine: (lines === undefined) ? false : true,
  rows: (lines === undefined) ? 1 : lines,
  fullWidth: true,
  underlineShow: false,
  floatingLabelText: title,
  hintText,
  hintStyle: {
    bottom: 7,
  },
  style: {
    fontSize: 16,
    fontWeight: 500,
    height: 70,
    padding: '0px 10px',
    //boxShadow: '0px 0px 2px 2px transparent',
  },
  floatingLabelShrinkStyle: {
    fontSize: 18
  },
  floatingLabelFocusStyle: {
    color: '#a0cef8',
    fontWeight: 500
  },
  floatingLabelStyle: {
    fontWeight: 400
  },
  underlineStyle: {
    margin: '-0px 0px -10px -10px'
  }
})

const PropsError = (result) => { //name, title, value

  //const result = FilterNames(name, title, value)

  const propsError = (result.isError) ? {
    floatingLabelText: result.message,
    style: {
      ...Props().style,
      //margin: '0px -1px 1px 0px',
      //border: '1px solid red'

      //boxShadow: '0px 0px 2px 2px rgba(255, 0, 0, 0.5)',
    },
    floatingLabelStyle: {
      ...Props().floatingLabelStyle,
      color: 'red'
    },
    floatingLabelFocusStyle: {
      ...Props().floatingLabelFocusStyle,
      color: 'red'
    },
  } : {}
  return ({ ...propsError })
};

const GetValue = (name, value) => {

  const result = (name !== undefined && value !== undefined) ? value[name] : undefined

  return ((result !== undefined) ? result : '')
}

const GetError = (errors, name) => {
  let result = { isError: false }
  if (errors !== undefined) {
    if (errors[name] !== undefined) {
      result = errors[name]
    }
  }
  return (result)
}

class inputText extends Component {
  render() {
    const { title, name, value, onChange, section, errors, lines, hintText } = this.props
    const id = section + name
    const props = { ...Props(title, lines, hintText), ...PropsError(GetError(errors, id)) }

    return (
      <div className='input-text' >
        <div className='input-text-container' >
          <TextField id={id} {...props} value={GetValue(name, value)} onChange={(evt) => onChange(name, evt.target.value, title, id)}/>
        </div>
      </div>
    )
  }
}

export default inputText



// WEBPACK FOOTER //
// ./src/shared/routes/components/inputText.js